import { Entity, Field } from "typegraph";

import { ID } from "common/entities/IEntity";
import Badge from "./Badge";
import  Entry  from "./Entry";

class Progress {

	@Field()
	public id: string;

	@Field()
	public name: string;

	@Field()
	public completed: number;

	@Field()
	public total: number;

	@Field()
	public progress: number;

	@Field()
	public type?: "Completion" | "Credit";
}

@Entity({one: "program", many: "programsUser"})
export default class Program {

	@Field()
	public id: ID;

	@Field()
	public name: string;

	@Field()
	public description: string;

	@Field()
	public completionType: "Completion" | "Credit";

	@Field({entity: Progress})
	public totalProgress: Progress;

	@Field({
		entity: Badge
		//includeIf: (data: any) => !!data.loadBadges
	})
	public badges: Badge[];

	@Field({
		entity: Entry,
		includeIf: (data: any) => !!data.loadTests
	})
	public preTest?: Entry;

	@Field({
		entity: Entry,
		includeIf: (data: any) => !!data.loadTests
	})
	public postTest?: Entry;
}



// WEBPACK FOOTER //
// ./src/panels/catalog/entities/ProgramCourse.ts